const API_URL = "https://seiban-shopifyapp-production-9dbc89d3d580.herokuapp.com"; //TODO: 変更必要

(() => {
  // const email = encodeURIComponent(localStorage.getItem("customer_email"));
  const email = encodeURIComponent(customer_email);

  fetch(API_URL + "/api/reserves/customer-list?email=" + email, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((res) => {
      const { data } = res;
      console.log({data})
        const appointment = document.querySelector("#appointment");
        if(appointment){
          const appointmentData = data.filter(item => item?.shop?.type === "実店舗");
          if(appointmentData.length > 0) {
          const htmlData = `
          <div>
            ${appointmentData
              .map(
                (item) => `
              <div class="reserve-item">
                <p class="shopname" >${item?.shop?.name}</p>
                <p class="reserve-time"><span>予約日時</span> ${formatDateString(item?.reserve_datetime)}</p>
                <div>
                ${
                  item.reserve_status === "予約済み"
                    ? '<button style="margin: 0;" onclick=cancelReverse(' +
                      item?.id +
                      ")>キャンセル</button>"
                    : ""
                }
                ${
                  item.reserve_status === "キャンセル済み"
                    ? '<div style="margin: 0;" class="cancel-reserve">キャンセル済み</div>'
                    : ""
                }
                </div>
              </div>
            `
                  )
                  .join("")}

              </div>
          `;
          appointment.innerHTML = htmlData;
          }else{
            appointment.innerHTML = "<p>実店舗の予約はありません。</p>";
          }
        }


          // イベント
        const event = document.querySelector("#appointment-event");
        if(event){
          // イベントのデータを取得
          const eventData = data.filter(item => item?.shop?.type === "イベント");
          if(eventData.length > 0) {
            eventData.forEach(item => {

            const htmlDataEvent = `
              <div class="reserve-item">
                <p class="shopname" >${item?.shop?.name}</p>
                <p class="reserve-time"><span>予約日時</span> ${formatDateString(item?.reserve_datetime)}</p>
                <div>
                ${
                  item.reserve_status === "予約済み"
                    ? '<button style="margin: 0;" onclick=cancelReverse(' +
                      item?.id +
                      ")>キャンセル</button>"
                    : ""
                }
                ${
                  item.reserve_status === "キャンセル済み"
                    ? '<div style="margin: 0;" class="cancel-reserve">キャンセル済み</div>'
                    : ""
                }
                </div>
              </div>
            `;
            event.innerHTML += htmlDataEvent;
          });
          }else{
            event.innerHTML = "<p>イベントの予約はありません。</p>";
          }
        }

        // 展示会
        const exhibition = document.querySelector("#appointment-exhibition");
        if(exhibition){
          const exhibitionData = data.filter(item => item?.shop?.type === "展示会");
          if(exhibitionData.length > 0) {
            exhibitionData.forEach(item => {
              const formattedDate = formatDateString(item?.reserve_datetime);
              const htmlDataExhibition = `
              <div class="reserve-item">
                <p class="shopname" >${item?.shop?.name}</p>
                <p class="reserve-time"><span>予約日時</span> ${formatDateString(item?.reserve_datetime)}</p>
                <div>
                ${
                  item.reserve_status === "予約済み"
                    ? '<button style="margin: 0;" onclick=cancelReverse(' +
                      item?.id +
                      ")>キャンセル</button>"
                    : ""
                }
                ${
                  item.reserve_status === "キャンセル済み"
                    ? '<div style="margin: 0;" class="cancel-reserve">キャンセル済み</div>'
                    : ""
                }
                </div>
              </div>
          `;
            exhibition.innerHTML += htmlDataExhibition;
          });
          }else{
            exhibition.innerHTML = "<p>展示会の予約はありません。</p>";
          }
        }
    });

function formatDateString(reserveDatetime) {
  const date = new Date(reserveDatetime);

  // 9時間を加算（JSTへ変換）
  date.setHours(date.getHours());

  // 各要素を取得
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 月は0から始まるので+1
  const day = date.getDate();
  const weekDayNames = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"];
  const weekday = weekDayNames[date.getDay()]; // 曜日を取得
  const hour = date.getHours().toString().padStart(2, "0"); // 時間を2桁にする
  const minute = date.getMinutes().toString().padStart(2, "0"); // 分を2桁にする

  // フォーマットされた文字列を返す
  return `${year}年${month}月${day}日（${weekday}） ${hour}:${minute}`;
}
})();

function cancelReverse(id) {
  // アラートを出してOKなら実行
  if(!confirm("予約をキャンセルしますか？")) {
    return;
  }

  fetch(API_URL + `/api/reserves/${id}/cancel-reserve`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if(res.status === 200) {
        alert("予約をキャンセルしました。");
        location.reload();
      }
    });
}
